
import { Component, Vue, Watch, Prop, Ref, Emit } from "vue-property-decorator";
import { namespace, Getter, Action } from "vuex-class";
import { MobileFeatures } from "@/store/mobile/types";
import UploadFileButton from "@/components/mobile/dispatch/UploadFileButton.vue";
import api from "@/services/api.service";
import { User } from "@/store/types";

const Mobile = namespace("mobile");

@Component({
	components: { UploadFileButton }
})

export default class ActiveUserList extends Vue {

    @Mobile.Getter("getMobileFeatures") getMobileFeatures: MobileFeatures;
	@Prop({ type: Boolean, required: true }) private showModal: boolean;

	private activeUsers: any[];
	private fields = ['fullName'];

	private async mounted()
	{
		const activeUsersFromDataService = await api.getAllActiveUsers();
		if (!activeUsersFromDataService) {
			this.activeUsers = [];
			return;
		}

		this.activeUsers = activeUsersFromDataService.map(x => ({
			fullName: x.fullName,
			//@ts-ignore
			userID: x.userID
		}));
	}

	private onRowClick(clickedUser)
	{
		this.$emit('update-active-user', clickedUser);
	}

	private onHide(value: string) {
		this.$emit('hide-active-user');
	}
}

